import React, { useEffect, useState } from 'react';
import { ChevronDownIcon, Input, Menu, Box, Pressable } from 'native-base';
import {
    GIFTCARD_FLOWS,
    GiftCardPayment,
    observer,
    useGetGiftCardPaymentList,
    useSpringBigStore,
    i18nFn,
} from '@springbig/shared';
import { useGeneralStyles } from '../../../shared/styles';
import { Caption } from '~/shared/Typography';
import Button from '~/shared/Button';
import OurPressable from '~/shared/Pressable';

const PaymentDropdown = ({
    paymentMethod,
    setPaymentMethod,
    t }: {
        paymentMethod: GiftCardPayment | null,
        setPaymentMethod: React.Dispatch<React.SetStateAction<GiftCardPayment | null>>
        t: i18nFn 
    }) => {

    const [isOpen, setMenuOpen] = useState(false);

    const gStyle = useGeneralStyles();
    const { giftCardPaymentList } = useSpringBigStore();
    const giftCardPaymentListQuery = useGetGiftCardPaymentList();

    useEffect(() => {

        giftCardPaymentListQuery?.refetch();
    }, []);

    const paymentCards = giftCardPaymentList?.filter(
        (payment: GiftCardPayment) => payment.card_nickname
    );


    const onPayemendAddPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.addPayment);
    };

    const handlePress = () => {
        setMenuOpen(!isOpen);
    };

    const onManagePaymentPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.managePayment);
    };

    return (
            <Input
                variant="underlined"
                p={2}
                keyboardType="numeric"
                placeholder="payment method"
                value={
                    paymentMethod &&
                    (paymentMethod.account_name ||
                        paymentMethod.card_nickname) || 'payment method'
                }
                isDisabled
                backgroundColor={'transparent'}
                color={gStyle.text}
                fontSize={18}
                fontWeight={300}
                borderBottomWidth={0.5}
                borderBottomColor={gStyle.text}
                InputRightElement={
                    <Menu
                        isOpen={isOpen}
                        onOpen={() => handlePress()}
                        onClose={() => handlePress()}
                        w={150}
                        padding={4}
                        borderRadius={24}
                        borderColor={gStyle.button_background}
                        backgroundColor={gStyle.screen_background}
                        borderWidth={1}
                        placement="bottom"
                        mr={4}
                        ml={"-20px"}
                        defaultIsOpen={false}
                        trigger={(triggerProps) => {

                            return (
                                <Pressable
                                    accessibilityLabel="More options menu"
                                    {...triggerProps}

                                >
                                    <ChevronDownIcon
                                        color={gStyle.button_background}
                                        size="lg"
                                    />
                                </Pressable>
                            );
                        }}
                    >
                        {paymentCards && (
                            <PaymentMethodMapper
                                paymentMethods={paymentCards}
                                setPaymentMethod={setPaymentMethod}
                                title="cards"
                            />
                        )}
                        {/* {paymentChecks && (
                            <PaymentMethodMapper
                                paymentMethods={paymentChecks}
                                setPaymentMethod={setPaymentMethod}
                                title="bank account"
                            />
                        )} */}
                        <Button
                            backgroundColor={gStyle.button_background}
                            width="75%"
                            mt={5}
                            alignSelf={'center'}
                            onPress={onPayemendAddPress}
                        >
                            <Caption color={gStyle.button_text} opacity={1}>
                                + payment
                            </Caption>
                        </Button>
                        <Button
                            backgroundColor={gStyle.button_background}
                            width="75%"
                            mt={5}
                            alignSelf={'center'}
                            onPress={onManagePaymentPress}
                        >
                            <Caption color={gStyle.button_text} opacity={1}>
                                {t('payment.manage')}
                            </Caption>
                        </Button>
                    </Menu>
                }
            />
    );
};

const PaymentMethodMapper = ({
    paymentMethods,
    setPaymentMethod,
    title,
}: {
    paymentMethods: GiftCardPayment[];
    setPaymentMethod: (method: GiftCardPayment) => void;
    title: string;
}) => {

    return (
        <>
            {paymentMethods &&
                paymentMethods.length > 0 && <PaymentTitle title={title} />}
            {paymentMethods &&
                paymentMethods.length > 0 &&
                paymentMethods.map((paymentMethod) => {

                    const { account_name, card_nickname } = paymentMethod;

                    return (
                            <Menu.Item
                                key={`${account_name || card_nickname}-${Math.random()}`}
                                padding={0}
                            >
                                <OurPressable marginX={-2} paddingY={2} paddingX={4} flex={1} onPress={() => setPaymentMethod(paymentMethod)}>
                                    <Caption fontSize={22} fontWeight={200}>
                                        x{account_name || card_nickname}
                                    </Caption>
                                </OurPressable>
                            </Menu.Item>
                    );
                })}
        </>
    );
};

const PaymentTitle = ({ title }: { title: string }) => {


    const gStyle = useGeneralStyles();

    return (
        <Box>
            <Caption
                width="100%"
                borderBottomWidth={2}
                borderBottomColor={gStyle.button_background}
                color={gStyle.button_background}
                fontSize={22}
                textAlign={'center'}
                fontWeight={200}
            >
                {title}
            </Caption>
            <Box
                borderBottomColor={gStyle.button_background}
                borderBottomWidth={1}
            />
        </Box>
    );
};

export default PaymentDropdown;
